import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Typography } from 'seagull';
import { ChevronLeft } from 'seagull/icons';
import { relationshipModel } from '~/models';
import styles from './MobilePane.module.scss';
export function MobilePane(param) {
    let { vendorDetails, hideBack, activeStepIndex, hideStepper, onBackClick, testId } = param;
    const vendorLogoUrl = relationshipModel.vendorLogoUrl({
        vendor: vendorDetails
    });
    if (hideStepper) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        "data-testid": testId && "".concat(testId, "-mobile"),
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: activeStepIndex > 0 && !hideBack && onBackClick ? /*#__PURE__*/ _jsx(IconButton, {
                    bi: {
                        name: 'mobile_pane_back_step'
                    },
                    onClick: ()=>onBackClick(activeStepIndex - 1),
                    testId: testId && "".concat(testId, "-mobile-back-btn"),
                    children: /*#__PURE__*/ _jsx(ChevronLeft, {})
                }) : null
            }),
            vendorLogoUrl ? /*#__PURE__*/ _jsx("img", {
                className: styles.logoImg,
                src: vendorLogoUrl
            }) : /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "normal",
                children: relationshipModel.vendorName({
                    vendor: vendorDetails
                })
            }),
            /*#__PURE__*/ _jsx("div", {})
        ]
    });
}
